import React from 'react'
import i18next from 'i18next'
import { Button } from 'react-bootstrap'
import { Trans } from 'react-i18next'
import ResponsiveTable from '../../system_wide/responsive_table'
import DealerContactsForm from './dealer_contacts_form'
import ActionsDropdown from '../../system_wide/actions_dropdown'
import { showConfirmDialog } from '../../system_wide/confirm_dialog'

const { t } = i18next

class DealerContacts extends React.Component {
  static defaultProps = {
    dealerContacts: [],
    readonly: false,
    notEditable: false,
    onChange: () => {},
    closeForm: () => {},
  }

  state = {
    current_dealer_contact: null,
    mode: '',
  }

  actions = [
    {
      icon: 'fas fa-eye',
      variant: 'outline-primary',
      text: t('actions.view', 'Visualizza'),
      onClick: rowData => {
        this.setState({ mode: 'view' })
        this.setCurrentDealerContact(rowData)
      },
    },
    {
      icon: 'fas fa-edit',
      variant: 'outline-warning',
      text: t('actions.edit', 'Modifica'),
      visible: () => !this.props.readonly && !this.props.notEditable,
      onClick: rowData => {
        this.setCurrentDealerContact(rowData)
      },
    },
    {
      icon: 'fas fa-trash-alt',
      variant: 'outline-danger',
      text: t('actions.delete', 'Elimina'),
      visible: () => !this.props.readonly && !this.props.notEditable,
      onClick: ({ name, surname, phone, email }) => {
        showConfirmDialog(
          <Trans i18nKey="components.dealer_contacts.delete_contact.title">Elimina Referente</Trans>,
          <Trans i18nKey="components.dealer_contacts.delete_contact.msg">
            Per procedere alla cancellazione del referente{' '}
            <b>
              {name} {surname}
            </b>{' '}
            clicca su Elimina
          </Trans>,
          () => {
            let dealer_contacts = this.props.dealerContacts.filter(
              contact =>
                !(
                  contact.name === name &&
                  contact.surname === surname &&
                  contact.phone === phone &&
                  contact.email === email
                )
            )

            this.props.onChange(dealer_contacts)
          },
          () => {},
          'primary',
          'Elimina'
        )
      },
    },
  ]

  actionsRenderer = ({ rowData }) => {
    return <ActionsDropdown rowData={rowData} actions={this.actions} />
  }

  columns = [
    {
      title: '',
      className: 'text-center',
      style: { width: '6%', minWidth: '3rem' },
      data: this.actionsRenderer,
    },
    {
      title: t('components.dealer_contacts.name', 'Nome'),
      className: 'd-none d-sm-block flex-fill',
      style: { width: '40%' },
      sortable: false,
      data: 'name',
    },

    {
      title: t('components.dealer_contacts.email', 'Email'),
      className: 'd-none d-sm-block flex-fill',
      style: { width: '30%' },
      sortable: false,
      data: 'email',
    },
    {
      title: t('components.dealer_contacts.phone', 'Telefono'),
      className: 'd-none d-sm-block flex-fill',
      style: { width: '30%' },
      sortable: false,
      data: 'phone',
    },

    {
      title: t('components.dealer_contacts.details', 'Dettagli'),
      className: 'd-block d-sm-none flex-fill',
      style: { width: '100%' },
      sortable: false,
      data: ({ rowData: { name, surname, email, phone } }) => {
        return (
          <div>
            <div>
              <strong>{t('components.dealer_contacts.name', 'Nome')}</strong>: {name}
            </div>
            <div>
              <strong>{t('components.dealer_contacts.surname', 'Cognome')}</strong>: {surname}
            </div>
            <div>
              <strong>{t('components.dealer_contacts.email', 'Email')}</strong>: {email ? email : '-'}
            </div>
            <div>
              <strong>{t('components.dealer_contacts.phone', 'Telefono')}</strong>: {phone ? phone : '-'}
            </div>
          </div>
        )
      },
    },
  ]

  tableDealerContactsRef = null
  constructor(props) {
    super(props)
    this.tableDealerContactsRef = React.createRef()
  }

  setCurrentDealerContact = (dealer_contact = {}) => {
    this.setState({
      current_dealer_contact: {
        name: dealer_contact.name ?? '',
        surname: dealer_contact.surname ?? '',
        phone: dealer_contact.phone ?? '',
        email: dealer_contact.email ?? '',
      },
    })
  }

  onAddDealerContact = dealer_contact => {
    let dealer_contacts = [...this.props.dealerContacts]
    //edit

    if (this.state.current_dealer_contact.name) {
      dealer_contacts = this.props.dealerContacts.map(contact => {
        let { name, surname, phone, email } = this.state.current_dealer_contact
        if (
          (contact.name || '') === (name || '') &&
          (contact.surname || '') === (surname || '') &&
          (contact.phone || '') === (phone || '') &&
          (contact.email || '') === (email || '')
        ) {
          return { ...dealer_contact }
        }
        return contact
      })
    } else {
      //new
      dealer_contacts.push(dealer_contact)
    }
    this.props.onChange(dealer_contacts)
    this.setState({ current_dealer_contact: null, mode: '' })
  }

  render() {
    let { current_dealer_contact, mode } = this.state
    return (
      <div className="d-flex flex-column" style={{ height: '20rem' }}>
        {this.props.readonly === false && (
          <div className="toolbar flex-wrap">
            <Button size="sm" onClick={this.setCurrentDealerContact}>
              <i className="fas fa-plus fa-fw text-start me-0" />
              <Trans i18nKey="components.dealer_contacts.add_contact">Aggiungi referente</Trans>
            </Button>
          </div>
        )}

        <ResponsiveTable
          ref={this.tableDealerContactsRef}
          className="flex-fill"
          data={this.props.dealerContacts}
          totalRecords={this.props.dealerContacts.length}
          columns={this.columns}
          disableMediaQuery={true}
          showMenu={current_dealer_contact !== null}
          modalSize="md"
          menuContent={DealerContactsForm}
          hideStatusBar={true}
          menuContentProps={{
            title: current_dealer_contact?.name
              ? t('components.dealer_contacts.edit_dealer_contact', 'Modifica referente')
              : t('components.dealer_contacts.add_dealer:contact', 'Aggiungi referente'),
            dealerContact: current_dealer_contact,
            onSave: this.onAddDealerContact,
            closeForm: () => {
              this.setState({ current_dealer_contact: null, mode: '' })
            },
            readonly: mode === 'view',
            forceUseModal: true,
          }}
        />
      </div>
    )
  }
}
export default DealerContacts
